import React, { useContext } from 'react'
import { StateMachineContext } from '../contexts/StateMachineProvider'
import { StyledFunnel } from './StyledFunnel'
import LoadingFunnel from './FunnelLoader'
import { lazy } from '../utils/utils'
import { useSelector } from '@xstate/react'
import {
  verifyQuestionMachineIsReady,
  verifyFunnelMachineIsInLoading,
  verifyFunnelMachineIsInErrorLoading,
  verifyFunnelMachineIsInIdle,
  verifyFunnelMachineIsInIntro
} from '../utils/machine_utils/FunnelMachine.selectors'
import { StyledButton } from './StyledButton'
import { funnelEvents } from '../events/eventMap'

const Funnel = () => {
  /**
   * A React hook for the funnelMachine with the questionMachine above
   * passed as an override
   */
  const stateMachineServices = useContext(StateMachineContext)
  const { funnelMachineService } = stateMachineServices
  const { send } = funnelMachineService

  const questionMachineShouldBeReady = useSelector(funnelMachineService, verifyQuestionMachineIsReady)

  const isIdle = useSelector(funnelMachineService, verifyFunnelMachineIsInIdle)
  const isLoading = useSelector(funnelMachineService, verifyFunnelMachineIsInLoading)
  const isErrorLoading = useSelector(funnelMachineService, verifyFunnelMachineIsInErrorLoading)
  const isIntro = useSelector(funnelMachineService, verifyFunnelMachineIsInIntro)

  const QuestionPanel = lazy(() => import(/* webpackChunkName: "QuestionPanel" */'./QuestionPanel'))
  const IntroPanel = lazy(() => import(/* webpackChunkName: "IntroPanel" */'./IntroPanel'))
  return (
    <>
      <React.Suspense fallback={<LoadingFunnel/>}>
        {(questionMachineShouldBeReady)
          ? <QuestionPanel />
          : <StyledFunnel className='funnel'>
            {isIdle && <StyledButton data-testid='idle_funnel' onClick={() => send(funnelEvents.start)}>start</StyledButton>}
            {isIntro && <IntroPanel />}
            {isErrorLoading &&
          <p className='message--error' data-testid='loading_funnel'>Error during loading. Reload to try again.</p>}

            {isLoading && <LoadingFunnel/>}
          </StyledFunnel>}
      </React.Suspense>
    </>
  )
}

export default Funnel
